// extracted by mini-css-extract-plugin
export default {"pageContainer":"SAQd20Si9VNd7orUU_n2__pageContainer___"};